// extracted by mini-css-extract-plugin
export const hero = "Hero-module--hero--1yNv_";
export const hero__img = "Hero-module--hero__img--1glN8";
export const hero__title = "Hero-module--hero__title--3Jcjm";
export const hero__text = "Hero-module--hero__text--o9VWe";
export const hero__videoLink = "Hero-module--hero__videoLink--2tmfQ";
export const hero__videoText = "Hero-module--hero__videoText--115fC";
export const hero__videoIcon = "Hero-module--hero__videoIcon--2mSTm";